import { useState, useRef, useCallback } from 'react';

export function useSyncState<T>(initialValue?: T) {
  const [state, setState] = useState<T | undefined>(initialValue);
  const stateRef = useRef<T | undefined>(initialValue);

  const setValue = useCallback((value: T | ((prev: T | undefined) => T) | undefined) => {
    if (typeof value === 'function') {
      stateRef.current = (value as (prev: T | undefined) => T)(stateRef.current);
    } else {
      stateRef.current = value;
    }
    setState(stateRef.current);
  }, []);

  return [state, setValue, stateRef] as const;
}
